module.exports = __webpack_public_path__ + "img/Smoking-attributable mortality in Hong Kong and high-income regions-added.2121e782.svg";